const paymentInThread = ({ thread, paymentID }) => {
  if (thread.payments && thread.payments.length) {
    return thread.payments.find((payment) => payment._id === paymentID);
  }
  return null;
};

export default paymentInThread;
